import React from 'react'
import { useSelector } from 'react-redux'
import MailIcon from '@material-ui/icons/Mail'
import Grid from '@material-ui/core/Grid'
import {
  WidgetContainer,
  WidgetContainerCard,
  CustomH5,
  CustomImage,
  StyledGrid,
  StyledParagraph,
  StyledManagerName,
  StyledSmallLink,
  EmailDiv
} from './styles'
import { theme, StyledExternalLink, svgIconStyle } from '../../../theme/Global'

const iconStyle = svgIconStyle({
  color: theme.colors.blueText,
  marginRight: '0.45rem',
  width: '24px'
})

const AccountContact = ({ type, cardBg }) => {
  const contact = useSelector((state) => state.account.company.accountManager)

  const renderContactInfo = () => {
    if (type === 'postings') {
      return (
        <div>
          <StyledParagraph>
            For poster order requests or to add a location, please email: <StyledExternalLink href="mailto:customerservice@govdocs.com">customerservice@govdocs.com</StyledExternalLink>
          </StyledParagraph>
          <StyledParagraph>
            For all other program assistance, please contact your Account Manager:
          </StyledParagraph>
        </div>
      )
    } if (type === 'minWagePaidLeave') {
      return (
        <div>
          <StyledParagraph>
            To make changes to your locations, please email: <StyledExternalLink href="mailto:customerservice@govdocs.com">customerservice@govdocs.com</StyledExternalLink>
          </StyledParagraph>
          <StyledParagraph>
            For all other program assistance, please contact your Account Manager:
          </StyledParagraph>
        </div>
      )
    }

    return (
      <StyledParagraph>
        Contact your Account Manager:
      </StyledParagraph>
    )
  }

  const Container = cardBg ? WidgetContainerCard : WidgetContainer

  return (
    <Container type={type}>
      <CustomH5>
        Need additional help?
      </CustomH5>
      {renderContactInfo(type)}
      <StyledGrid container>
        <Grid item xs={5}>
          <CustomImage image={contact.accountManagerPhoto} />
        </Grid>
        <Grid item xs={7}>
          <StyledManagerName>
            {contact.fullName}
          </StyledManagerName>
          <StyledSmallLink href={`mailto:${contact.email}`}>
            <MailIcon style={iconStyle} />
            <EmailDiv>
              Email Me
            </EmailDiv>
          </StyledSmallLink>
        </Grid>
      </StyledGrid>
    </Container>
  )
}

export default AccountContact
